import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { ListItem, ListItemColumn } from '@core/models/list-item.model';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ListItemComponent {
  @Input() data: ListItem = {} as ListItem;
  @Output() public onClicked: EventEmitter<void> = new EventEmitter();

  /* Ausgelagert, weil leichter lesbar und so wird es schöner gerendert im DOM */
  getColClassList(col: ListItemColumn) {
    let classList = '';
    if (col.alignSm) {
      classList += '__align-sm-' + col.alignSm + ' ';
    }
    if (col.size) {
      classList += col.size + ' ';
    } else {
      classList += '__no-size-defined ';
    }
    if (col.hiddenSm) {
      classList += '__hidden-sm';
    }
    if (col.image) {
      classList += '__image-col ';
    }
    return classList;
  }
}
